import { render, staticRenderFns } from "./GradedAssignment.vue?vue&type=template&id=d252085c&scoped=true"
import script from "./GradedAssignment.vue?vue&type=script&lang=js"
export * from "./GradedAssignment.vue?vue&type=script&lang=js"
import style0 from "./GradedAssignment.vue?vue&type=style&index=0&id=d252085c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d252085c",
  null
  
)

export default component.exports